export default {
    watch: {
        perPage(current, previous) {
            this.dataLoading();
        }
    },

    created() {
        this.$set(this, 'perPage', this.$root.perPage);
    },

    data() {
        return {
            perPage:        12,
            perPageOptions: [12, 24, 50, 100],
            isFirstLoad:    true,
            isLoading:      false
        };
    },

    methods: {
        changePerPage() {
            this.$set(this.$root, 'perPage', this.perPage);
            this.$ls.set('perPage', this.perPage);

            this.$events.fire('refreshTableData');
        },

        dataLoading() {
            this.$set(this, 'isLoading', true);
        },

        dataLoaded() {
            this.$set(this, 'isFirstLoad', false);
            this.$set(this, 'isLoading', false);
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/TablePagination.js